import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchNoToken } from "../../app/helpers/fetch";
import { const_routes } from "../../app/helpers/const_routes";

const ConfirmEmailChange = () => {
  const { token } = useParams();
  const { t } = useTranslation();
  const [status, setStatus] = useState("pending");
  const [message, setMessage] = useState("");

  useEffect(() => {
    let cancelled = false;
    const confirm = async () => {
      const resp = await fetchNoToken(
        const_routes.SCHEMA,
        const_routes.VERSIONV1,
        const_routes.ROUTE_USER_PREFERENCES,
        "email/confirm",
        { token },
        "POST"
      );
      const body = await resp.json();
      if (cancelled) return;
      if (body.ok) {
        setStatus("ok");
      } else {
        setStatus("error");
        setMessage(body.msg || "");
      }
    };
    if (token) confirm();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      {status === "ok" ? (
        <div>
          <i className="fa fa-check-circle" style={{ fontSize: "3rem", color: "green" }}></i>
          <h2 style={{ marginTop: "15px" }}>{t("accountPreferences.emailConfirmedTitle")}</h2>
          <span>{t("accountPreferences.emailConfirmed")}</span>
        </div>
      ) : status === "error" ? (
        <div>
          <i className="fa fa-exclamation-circle" style={{ fontSize: "3rem", color: "#b8860b" }}></i>
          <h2 style={{ marginTop: "15px" }}>{t("accountPreferences.emailConfirmFailed")}</h2>
          <span>{message}</span>
        </div>
      ) : (
        <span>{t("accountPreferences.emailConfirming")}</span>
      )}
    </div>
  );
};

export default ConfirmEmailChange;
